import JSONSchemaView from './json-schema-view';
import './style.less';

window['JSONSchemaView'] = JSONSchemaView;

export default JSONSchemaView;



// WEBPACK FOOTER //
// ./src/index.js